import React from 'react';
import { FileImage, ExternalLink } from 'lucide-react';
import useBlockStyles from '../common/useBlockStyles';

const STYLE_OPTIONS = {
  defaultBackground: 'section',
  defaultHeadingSize: 'medium',
  defaultAlignment: 'center',
  defaultPadding: 'normal',
};

const FileEmbedRenderer = ({ block, theme = {} }) => {
  const { content } = block;
  const { heading, files = [] } = content;
  const styles = useBlockStyles(content, theme, STYLE_OPTIONS);

  // Empty state
  if (!files.length) {
    return (
      <div
        className={`w-full ${styles.sectionPaddingClass}`}
        style={{ backgroundColor: styles.sectionBackground }}
      >
        <div className="max-w-3xl mx-auto text-center">
          <FileImage size={48} className="mx-auto mb-4" style={{ color: styles.mutedColor }} />
          <p style={{ color: styles.mutedColor }}>No files uploaded</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`w-full ${styles.sectionPaddingClass}`}
      style={{ backgroundColor: styles.sectionBackground }}
    >
      <div className="max-w-3xl mx-auto space-y-6">
        {heading && (
          <h2
            className={`${styles.headingSizeClass} font-bold text-center`}
            style={{ color: styles.headingColor, fontFamily: styles.headingFontStyle }}
          >
            {heading}
          </h2>
        )}

        {files.map((file) => {
          const isPdf = file.fileType === 'pdf';

          if (isPdf) {
            return (
              <div key={file.id} className="space-y-2">
                <iframe
                  src={file.url}
                  title={file.fileName}
                  className="w-full rounded-lg border"
                  style={{
                    height: 'clamp(400px, 80vh, 800px)',
                    borderColor: styles.borderColor,
                  }}
                />
                <a
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-1.5 text-sm hover:underline w-full"
                  style={{ color: styles.accentColor || styles.mutedColor }}
                >
                  <ExternalLink size={14} />
                  Open in new tab
                </a>
              </div>
            );
          }

          // Image
          return (
            <div key={file.id}>
              <img
                src={file.url}
                alt={file.fileName}
                className="w-full h-auto rounded-lg"
                loading="lazy"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FileEmbedRenderer;
